/* global  */ // tUrl等のグローバル変数を宣言する
import Swiper from 'swiper' // Swiper

jQuery(function($) {
  localStorage.setItem('opAnime', 'true') // アニメーションが実行されたことを保存
  if ($('.TOPswiper-container')[0]) {
    // Swiperコンテナを検出したら実行
    // eslint-disable-next-line no-unused-vars
    const mvSwiper = new Swiper('.TOPswiper-container', {
      effect: 'fade', // slide,fade,cube,coverflow
      speed: 1000, // アニメ速度
      loop: true, // ループ
      loopAdditionalSlides: 10, //ループ演出用のクローン数を増やして安定化させる
      // centeredSlides: true,
      slidesPerView: 1, //表示数変更
      spaceBetween: 0, //スライド同士の間隔を空ける
      autoplay: {
        delay: 2000, // 待機時間
        disableOnInteraction: false // 操作されたらオート解除
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true
      },
      breakpoints: {
        1000: {
          centeredSlides: true,
          loopAdditionalSlides: 10,
          slidesPerView: 1
        }
      }
    })
  }
  $(window).on('scroll', function() {
    var elem = $('.scrollElem')
    var isAnimate = 'isAnimate'

    elem.each(function() {
      var elemOffset = $(this).offset().top
      var scrollPos = $(window).scrollTop()
      var wh = $(window).height()

      if (scrollPos + 120 > elemOffset - wh + wh / 2) {
        $(this).addClass(isAnimate)
      }
    })

    var video = document.getElementById('opAnimeVideo')
    var scrollThreshold = 700 // スクロールの閾値を500ピクセルに設定

    var currentScrollPos = window.scrollY || document.documentElement.scrollTop

    if (currentScrollPos >= scrollThreshold) {
      if (!video.paused) {
        video.pause() // ビデオを一時停止
      }
    } else {
      if (video.paused) {
        video.play() // ビデオを再生
      }
    }
  })
  $('#trading-studioClickTarget').on('click', function() {
    // クリックされた要素にクラスを付与または排除
    if ($('#trading-studio-dialog').hasClass('visible')) {
      $('#trading-studio-dialog').removeClass('visible')
    } else {
      $('#trading-studio-dialog').addClass('visible')
    }
  })
  $('#trading-studio-dialog-closeBtn').on('click', function() {
    // クリックされた要素にクラスを付与または排除
    if ($('#trading-studio-dialog').hasClass('visible')) {
      $('#trading-studio-dialog').removeClass('visible')
    } else {
      $('#trading-studio-dialog').addClass('visible')
    }
  })
})
